import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { DataGrid, DataGridProps } from '@mui/x-data-grid';
import React from 'react';
import { useTranslation } from 'react-i18next';
import SGSPagination from './SGSPagination';

type Props = DataGridProps & {
    noHeader?: Boolean;
    noRowsLabel?: string;
    autoHeight?: Boolean;
    rowMargin?: number;
};

const useStyles = makeStyles((_theme: Theme) =>
    createStyles({
        root: {
            border: 'none',
            fontSize: 13,
            '& .MuiDataGrid-columnsContainer': {
                border: 'none',
            },
            '& .MuiDataGrid-colCellTitle': {
                fontFamily: "'Open Sans Bold', sans-serif",
                fontSize: 16,
            },
            '& .MuiDataGrid-row': {
                marginTop: (props: Props) => props.rowMargin,
                marginBottom: (props: Props) => props.rowMargin,
            },
            '& .MuiDataGrid-cell': {
                border: 'none',
                lineHeight: 'normal !important',
                display: 'flex',
                alignItems: 'center',
                '&:focus': {
                    outline: 'none',
                },
            },
            '& .MuiDataGrid-footer': {
                flexDirection: 'column',
                justifyContent: 'center',
            },
        },
    }),
);

const SGSDataGrid: React.FC<Props> = ({ noHeader, noRowsLabel, autoHeight = true, rowMargin = 2, ...props }) => {
    const classes = useStyles({ noHeader, noRowsLabel, autoHeight, rowMargin, ...props });
    const { t } = useTranslation();
    return (
        <DataGrid
            {...props}
            disableColumnMenu
            autoHeight={autoHeight}
            //disableColumnReorder
            className={classes.root}
            components={{ Pagination: SGSPagination }}
            {...(noHeader && { headerHeight: 0 })} // Optional attribute
            localeText={{ noRowsLabel: noRowsLabel || t('components.datagrid.noRows') }}
        />
    );
};

export default SGSDataGrid;
